import { createTheme } from '@material-ui/core/styles';

export default createTheme({
    palette: {
        primary: {
            main: '#73926C',
            contrastText: '#fff',
        },
        secondary: {
            main: '#EDA909',
            contrastText: '#fff',
        },

    }
});
